import { oneLineTrim } from 'common-tags';

// What is this?
export function isNumericKey(e, withDecimal) {
  const key = e.charCode || e.keyCode || 0;

  return (
    key == 8 ||
    key == 9 ||
    key == 46 ||
    (key >= 37 && key <= 40) ||
    (key >= 48 && key <= 57) ||
    (key >= 96 && key <= 105) ||
    (withDecimal && (key == 110 || key == 190))
  );
}

/* AUTO INCREASE LANDING PAGE COUNTER */
export function addCommas(nStr) {
  nStr = String(nStr);
  const x = nStr.split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? `.${x[1]}` : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1,$2');
  }
  return x1 + x2;
}

export function isValidEmail(email) {
  // TODO: Check unit test as the regex has failed to catch no TLD domains.
  const re = new RegExp(
    oneLineTrim`^(([^<>()\\[\\]\\\.,;:\\s@"]+(\\.[^<>()\\[\\]
    \\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]
    {1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$`,
  );
  return re.test(email);
}

/*
 * Opposite to ajax/check-email-blocked.php
 * Returns Promise
 * - If Email is Blocked, return true
 * - If Email is not Blocked, return false
 */
export function isBlockedEmail(email) {
  const encodedEmail = encodeURIComponent(email);
  return fetch(`/ajax/check-email-blocked.php?email=${encodedEmail}`)
    .then(response => response.text())
    .then(response => {
      if (response == 'true') {
        return false;
      }
      return true;
    });
}

export function isValidUsernameFormat(username) {
  const re = /^[a-z][a-z0-9]{2,15}$/i;
  return re.test(username);
}

export function isValidPasswordFormat(password) {
  const len = password.length;
  const nums = password.match(/\d/g);
  const lowers = password.match(/[a-z]/g);
  const uppers = password.match(/[A-Z]/g);
  const pattern = /^.{6,}$/i;

  if (pattern.test(password)) {
    let strengthLevel = 0;
    if (nums) {
      strengthLevel += 2;
    }
    if (lowers) {
      strengthLevel += uppers ? 4 : 3;
    }
    if (uppers) {
      strengthLevel += lowers ? 4 : 3;
    }
    if (len > 10) {
      strengthLevel += 1;
    }

    if (strengthLevel <= 4) {
      return false;
    } else if (strengthLevel > 4 && strengthLevel <= 8) {
      return true;
    }

    return true;
  }
  return false;
}

/* Retrieve a value from an object by following the given path.
 *
 *   const obj = { messages: { value: 1 } };
 *   view('messages.value', obj); // => 1
 *
 * Also supports array indices in the path e.g. `object.array.1`
 * will retrieve the 1th item from a zero-indexed array named `array`.
 */
export const view = (path, obj) =>
  path.split('.').reduce((o, p) => (o ? o[p] : o), obj);

/* Tell if a path exists in the given object.
 *
 *   const obj = { messages: { value: 1 } };
 *   has('messages.value', obj); // => true
 *
 * Also supports array indices in the path e.g. `object.array.1`
 * will retrieve the 1th item from a zero-indexed array named `array`.
 */
export const has = (obj, path) => !!view(path, obj);

/**
 * Given a string URL, retrieve the query parameter as JSON object
 * @param string url URL you normally get by calling window.location.href
 * @return Object
 */
export const convertParametersFromUrl = url => {
  const indexOfQueryString = window.location.href.indexOf('?');
  if (indexOfQueryString < 1) {
    return {};
  }
  const searchString = url.substring(url.indexOf('?') + 1);
  if (searchString == '') {
    return {};
  }
  const params = searchString.split('&').reduce((paramObj, param) => {
    const parameter = param.split('=');
    if (parameter[0] && parameter[1]) {
      paramObj[parameter[0]] = parameter[1];
    }
    return paramObj;
  }, {});
  return params;
};
